import { ListItemIcon, MenuItem } from '@mui/material';
import { PermissionCheck, usePermissions } from '@procureai/permissions-ui';
import { PageTitleWithMenu } from '@procureai/ui-mui';
import { ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { DomainIcon } from '../DomainIcon/DomainIcon';
import { IntakeDomain, IntakeDomainType, I18nNamespace } from '~/common/types';
import { RouteId } from '~/routes';
import { mapTruthy } from '~/util/array';

type DomainSelectItem = { id: IntakeDomain; neededPermission?: PermissionCheck };

const domainSelectItems: DomainSelectItem[] = [
  {
    id: IntakeDomainType.INTAKE,
  },
];

export interface IntakePageTitleProps {
  domain?: IntakeDomain;
}
// TODO: Is that even required? #Steffen
const routeIdMap: { [key in IntakeDomainType]?: string } = {
  [IntakeDomainType.INTAKE]: RouteId.intake,
};

export const IntakePageTitle = ({ domain }: IntakePageTitleProps) => {
  const { t } = useTranslation(I18nNamespace.intake);
  const { hasPermission } = usePermissions();

  const menuItems = mapTruthy<DomainSelectItem, ReactNode>(({ id, neededPermission }) => {
    const selected = id === domain;
    if (!neededPermission || hasPermission(neededPermission)) {
      return (
        <MenuItem key={id} component={RouterLink} to={routeIdMap[id] ?? RouteId.demand} selected={selected}>
          <ListItemIcon>
            <DomainIcon domain={id} />
          </ListItemIcon>
          <span>{t(`Intake.title`)}</span>
        </MenuItem>
      );
    }
    return null;
  })(domainSelectItems);

  const title = t(`Intake.title`);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <PageTitleWithMenu title={title} disabled={menuItems.length <= 1}>
        {menuItems}
      </PageTitleWithMenu>
    </>
  );
};
